import {
  getModelNameById,
  getCategoryIdByModelId,
  getCategoryNameByModelId,
} from '@/components/combined-predict/modelAdapterService'
import { groupBy } from 'lodash-es'
import { toddsModelsId } from '@/components/combined-predict/models/toddsModels/toddsModelMetadata'

const getModelNameByIdWithCategory = (modelId) => {
  const name = getModelNameById(modelId)
  const categoryName = getCategoryNameByModelId(modelId)
  return categoryName ? `${categoryName} - ${name}` : name
}

const categoryIdsToInclude = [toddsModelsId]

const shouldBeGrouped = (modelId) => {
  const categoryId = getCategoryIdByModelId(modelId)
  return categoryIdsToInclude.includes(categoryId)
}
const formatModelErrorsForDisplay = (errorsByModelId) => {
  if (!errorsByModelId) return null
  const errorsToProcess = Object.entries(errorsByModelId).filter(([modelId, error]) => !!error)
  const groupedErrors = groupBy(errorsToProcess, ([modelId, error]) => {
    return shouldBeGrouped(modelId) ? getCategoryNameByModelId(modelId) : 'other'
  })
  const allErrorsIdentical = (modelErrorEntries) =>
    modelErrorEntries?.length > 1 && new Set(modelErrorEntries.map(([, error]) => error)).size === 1

  return Object.entries(groupedErrors).reduce((acc, [category, errorWithModelIdArray]) => {
    if (category !== 'other') {
      if (allErrorsIdentical(errorWithModelIdArray)) {
        acc[category] = errorWithModelIdArray[0][1]
        return acc
      }

      errorWithModelIdArray.forEach(([modelId, error]) => {
        acc[getModelNameByIdWithCategory(modelId)] = error
      })
      return acc
    }

    errorWithModelIdArray.forEach(([modelId, error]) => {
      acc[getModelNameById(modelId)] = error
    })

    return acc
  }, {})
}

export { formatModelErrorsForDisplay }
